import React from "react";
import { useNavigate } from "react-router";
import { Button } from "@mui/material";

import "./error404.scss";

const Error404: React.FC = (): JSX.Element => {
	const navigate = useNavigate();

	const handleRedirectToHomePageClick = () => {
		navigate("/");
	};
	return (
		<div className="error-page">
			<div className="container-404">404</div>
			<div className="error-page-container">
				<h2>WE ARE SORRY , PAGE NOT FOUND!</h2>
				<p>
					THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED HAD ITS NAME CHANGED OR IS TEMPORARILY
					UNAVAILABLE.
				</p>
				<Button
					onClick={handleRedirectToHomePageClick}
					variant="contained"
					className="back-to-home-page-button"
				>
					BACK TO HOMEPAGE
				</Button>
			</div>
		</div>
	);
};

export default Error404;
